// extracted by mini-css-extract-plugin
module.exports = {"title":"antd-pro-pages-result-success-index-title","head-title":"antd-pro-pages-result-success-index-head-title"};